<template>
        <j-modal
        :title="title"
        :width="width"
        :visible="visible"
       :maskClosable="false"
       :switchFullscreen="false"
       :fullscreen="false"
    @ok="visible = false"
    @cancel="visible = false"
         cancelText="关闭">
    <a-list item-layout="horizontal" style="height: 98%;">
      <a-list-item :key="key" v-for="(obj2, key) in imgList">
        <img  alt="example" style="width: 100%;" :src="obj2.src"  @click="handleImgView(obj2.src)" />
      </a-list-item>
    </a-list>

     <template slot="footer">
      <a-button key="submit" type="default" @click="visible = false"> 关闭 </a-button>
    </template>        
 </j-modal>
</template>

<script>

import { deleteAction, getAction,downFile,getFileAccessHttpUrl } from '@/api/manageChooseSeat'
  export default {
    name: 'ViewImage',
    components: {
      
    },
    data() {
      return {
        title:'查看图片',
        width:800,
        visible: false,
        imgList:[],
        isImage:false
      }
    },
  
    methods:{
      viewimage (imgpath) {
        this.imgList=[];
        if(imgpath!="")
        {
            let arr = imgpath.split(",")
            for(let i=0;i<arr.length;i++){
                let url = getFileAccessHttpUrl(arr[i]+"?applicationCode=chooseseat")
                let c = {key:i, src:url,filename:arr[i]}
                this.imgList.push(c );
              
            }
        }
        this.visible=true;
      },
      handleImgView(url)
      {
        window.open(url);
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>

<style scoped>
</style>